import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SettingButtonComponent } from 'src/app/shared/components/account/setting-button/setting-button.component';
import { UserAvatarComponent } from 'src/app/shared/components/account/user-avatar/user-avatar.component';
import { SentrynelButtonComponent } from "../../shared/components/account/sentrynel-button/sentrynel-button.component";
import { AuthService } from "src/app/core/services/auth.service";


@Component({
    selector: 'app-header',
    standalone: true,
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    host: { 'class': 'bg-bluegray-50' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        UserAvatarComponent,
        SettingButtonComponent,
        SentrynelButtonComponent
    ]
})
export class HeaderComponent {
  @Input() title?: string;
  @Input() logo?: string;
  @Input() showTitle: boolean = true;
  @Input() showLogo: boolean = true;
  roles = computed(()=>this.authService.user()?.authorization.roles)  ?? []
  constructor(
    private authService: AuthService,
  ){

  }

  findSuperAdmin(){
    return this.roles()?.indexOf("SuperAdmin") > -1
  }
}
